import { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";
import { useGetAllDepartments } from "../api/getAllDepartments";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";

// All your logic is here
export const useDepartmentsDataViewLogic = () => {
  const { activeFilters } = useContext(SydFilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({action: "", selectedRows: []});
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetDepartment["data"]>([]);
  const getAllDepartmentsQuery = useGetAllDepartments({data: activeFilters as IDepartmentSearchForm});
  const { t } = useTranslation();

  const loadingDone = [getAllDepartmentsQuery].every(({ isFetching }) => !isFetching);

  const isError = [getAllDepartmentsQuery].some(({ isError }) => isError);

  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" }
  ];

  const data = getAllDepartmentsQuery.data ? getAllDepartmentsQuery.data.data : [];
  const apiTotalRecords = getAllDepartmentsQuery.data ? getAllDepartmentsQuery.data.totalRercords : 0;

  const columnData = [
    {
      columnName: "id",
      columnDisplayName: "ID",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "description",
      columnDisplayName: "Περιγραφή",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "unID",
      columnDisplayName: "Κωδικός",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "deleted",
      columnDisplayName: "Διαγραμμένο",
      visible: true,
      columnOrder: 4,
      isDraggable: false,
      columnDataType: "Boolean",
    }
  ]

  const columns = useMemo(() => {
    console.log("columnData",columnData)
    return convertApiHeaderToReactTableHeader(
      columnData ,
      dataTypes
    );
  }, []);

  const closeActionModal = () => {
    setModalEvent({ action: "", selectedRows: [] });
  };

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Διεύθυνσης");
        break;
      case "edit":
        title = t("Επεξεργασία Διεύθυνσης");
        break;
      case "delete":
        title = t("Διαγραφή Διεύθυνσης");
        break;
      case "showDetails":
        title = t("Λεπτομέρειες");
        break;
      default:
        break;
    }
    return title;
  };

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable && selectedRowsOfTable[0]
      ? [...[selectedRowsOfTable[0].id]]
      : [];
    setModalEvent({ action: event.action, selectedRows: selectedRows });
  };



  useEffect(() => {
    setSelectedRowsOfTable([]);
    getAllDepartmentsQuery.refetch();
  }, [activeFilters]);

  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    apiTotalRecords,
    isError
  };
};
